import { render, staticRenderFns } from "./richTextEditor.vue?vue&type=template&id=1de17fa9"
import script from "./richTextEditor.vue?vue&type=script&lang=js"
export * from "./richTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports